module.exports = __webpack_public_path__ + "media/25-Basirat_Naphew_Testimonial.e3234757.mp3";